import Udesk from 'Udesk';
import React from 'react';
import { Input, Select } from 'udesk-ui';

const Template = (props) => {
    const { onChange, value = {} } = props;

    const { operator, score } = value;

    const onSelect = (v) => {
        onChange({
            ...value,
            operator: v,
        });
    };
    const onInput = (v) => {
        onChange({
            ...value,
            score: v.target.value,
        });
    };
    return (
        <Input
            addonBefore={
                <Select
                    onChange={onSelect}
                    value={operator}
                    style={{ width: 75 }}
                    options={Udesk.enums.gradedOptions.map((i) => ({ label: i.name, value: i.id }))}
                ></Select>
            }
            value={score}
            onChange={onInput}
        />
    );
};

export default Template;
